/*import { FETCH_ORDER } from "constants/ActionTypes";

const INIT_STATE = [];

export default (state = INIT_STATE, action ) => {
    switch (action.type) {
        case FETCH_ORDER: {
            if (action.payload == undefined) {
                return state;
            } else {
                const newState = action.payload.map( (value) => {
                    return value
                });
                return newState;
            }
        } ;
        default:
            return state;
    }
}
*/
import {
    FETCH_ORDER,
} from "constants/ActionTypes";

const INIT_STATE = [];

 export default (state = INIT_STATE , action) => {
    switch(action.type) {
        case FETCH_ORDER : {
            if (action.payload == undefined || action.payload == []|| action.payload==null) {
                return state;
            } else {
               // console.log('action test',action)
                const data = Array.from(action.payload)
                const newState = data.map( (value) => {
                    return value
                });
                return newState;
            }
        } ;
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/appRedux/reducers/Orders.js